import React, { createContext, useContext } from 'react';
import { PostTemplate, GeneralSettings, FloaterBar } from 'types/globalTypes';

interface ACFContextValue {
	postTemplate?: PostTemplate;
	generalSettings?: GeneralSettings;
	floaterBar?: FloaterBar;
}

const ACFContext = createContext<ACFContextValue>({});

interface ACFProviderProps {
	children: React.ReactNode;
}

export const ACFProvider: React.FC<ACFProviderProps> = ({ children }) => {
	const postTemplate = typeof window !== 'undefined' ? window.post_template : undefined;
	const generalSettings = typeof window !== 'undefined' ? window.general_settings : undefined;
	const floaterBar = typeof window !== 'undefined' ? window.floater_bar : undefined;
	return <ACFContext.Provider value={{ postTemplate, generalSettings, floaterBar }}>{children}</ACFContext.Provider>;
};

export function useACF() {
	return useContext(ACFContext);
}
